export const colors = {
  grey: {
    1: '#b5b5b5',
    2: 'rgba(154, 150, 147, .6)'
  }
}
